import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0ce45977"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "project-detail-right-box"
};
const _hoisted_2 = {
  class: "rs4"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "ui label"
}, "热门项目", -1));
const _hoisted_4 = ["href"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "ui label"
}, "欢迎咨询", -1));
const _hoisted_6 = {
  class: "r1-head"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "欢迎关注我们的团队公众号AI小助手，咨询项目源码等相关内容。", -1));
const _hoisted_8 = ["src"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "r1-body"
}, null, -1));
const _hoisted_10 = ["src"];
import image_scroll from '../../../assets/scroll.png';
import { useScroll } from "@vueuse/core";
import { onMounted, onUnmounted, ref, watch } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectDetailDetailRight',
  props: {
    projectTopFiveList: {}
  },
  setup(__props) {
    const {
      y
    } = useScroll(window);
    const toTopFun = () => {
      let timer = setInterval(function () {
        //获取滚动条距离顶部高度
        const osTop = document.documentElement.scrollTop || document.body.scrollTop;
        const iSpeed = Math.floor(-osTop / 7);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + iSpeed;
        //到达顶部，清除定时器
        if (osTop == 0) {
          clearInterval(timer);
          timer = null;
        }
      }, 30);
    };
    const props = __props;
    watch(() => props.projectTopFiveList, newVal => {
      if (newVal.length > 0) {
        newVal.forEach(item => {
          item.count = formattedViewCount(Number(item.count));
        });
      }
    });
    // // 创建伪造的数据
    // const browseList = ref([
    //   {id: 1, title: 'Web恶意流量检测工具，支持pcap包检测', viewCount: 12000},
    //   {id: 2, title: '基于机器学习的入侵检测系统ids', viewCount: 850},
    //   {id: 3, title: '基于SpringBoot的社团管理系统的设计与实现', viewCount: 920},
    //   {id: 4, title: '基于微信小程序校园水电费管理微信小程序的设计', viewCount: 710},
    //   {id: 5, title: '基于Django的租房信息可视化分析系统的设计与实现', viewCount: 650}
    // ])
    const isMobile = ref(false);
    const formattedViewCount = count => {
      if (count >= 10000) {
        return (count / 10000).toFixed(2) + '万';
      }
      return count.toString();
    };
    const checkIfMobile = () => {
      isMobile.value = window.innerWidth <= 768; // 根据需要调整判断条件
    };
    onMounted(() => {
      checkIfMobile();
      window.addEventListener('resize', checkIfMobile);
    });
    onUnmounted(() => {
      window.removeEventListener('resize', checkIfMobile);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_hoisted_3, _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectTopFiveList, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index
        }, [_createElementVNode("a", {
          href: '/business/project/detail/' + item.id,
          target: "_blank"
        }, _toDisplayString(item.name), 9, _hoisted_4), _createTextVNode(" —— " + _toDisplayString(item.count) + " 次浏览 ", 1)]);
      }), 128))])]), _createElementVNode("section", null, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("img", {
        style: {
          "width": "200px",
          "height": "200px"
        },
        src: require('../../../assets/ai-niuzhanAccount.jpg'),
        alt: ""
      }, null, 8, _hoisted_8)]), _hoisted_9]), !isMobile.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_unref(y) > 600 ? 'toTop hidden' : 'toTop goTop hidden'),
        onClick: toTopFun
      }, [_createElementVNode("img", {
        src: _unref(image_scroll),
        alt: ""
      }, null, 8, _hoisted_10)], 2)) : _createCommentVNode("", true)]);
    };
  }
});